"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _Menu = _interopRequireDefault(require("@mui/material/Menu"));
var _ = require("./..");
var _Avatar = _interopRequireDefault(require("@mui/material/Avatar"));
var _fa = require("react-icons/fa");
var _colors = require("@mui/material/colors");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
//import { securityUtil } from "@indigenux/indi";

const AccountAvatar = _ref => {
  let {
    id
  } = _ref;
  const isLoggedIn = () => {
    return false; //securityUtil.isLoggedIn();
  };
  const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  const open = Boolean(anchorEl);
  const loggedIn = Boolean(isLoggedIn());
  const handleAccountMenuClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
    //securityUtil.logout();
    window.location.replace("/logout");
  };
  const accountMenuOpen = evt => {
    setAnchorEl(evt.currentTarget);
  };
  const determineAvatarText = () => {
    return "T";
  };
  const getSupportedLanguages = () => {
    return [{
      title: 'English',
      href: '/english'
    }, {
      title: 'Spanish',
      href: '/spanish'
    }, {
      title: 'German',
      href: '/german'
    }];
  };
  const avatarBackgroundColor = loggedIn ? _colors.deepOrange[500] : _colors.grey[300];
  const avatarIcon = loggedIn ? determineAvatarText() : /*#__PURE__*/(0, _jsxRuntime.jsx)(_fa.FaUserSlash, {});
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
    marginLeft: 4,
    id: id,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Avatar.default, {
      sx: {
        bgcolor: avatarBackgroundColor
      },
      onClick: accountMenuOpen,
      children: avatarIcon
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Menu.default, {
      id: "basic-menu",
      anchorEl: anchorEl,
      open: open,
      onClose: handleAccountMenuClose,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
        sx: {
          display: loggedIn ? 'auto' : 'none'
        },
        onClick: () => {
          window.location.replace("/account/general");
        },
        children: "Manage account"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
        divider: true,
        sx: {
          display: loggedIn ? 'auto' : 'none'
        },
        onClick: handleLogout,
        children: "Logout"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
        sx: {
          display: loggedIn ? 'none' : 'auto'
        },
        onClick: () => {
          window.location.replace("/register");
        },
        children: "Register"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
        divider: true,
        sx: {
          display: loggedIn ? 'none' : 'auto'
        },
        onClick: () => {
          window.location.replace("/login");
        },
        children: "Login"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
        display: "flex",
        flexWrap: 'wrap',
        paddingTop: 1,
        paddingX: 0.5,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          paddingRight: 0.5,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.LanguageSelector, {
            title: 'English',
            id: 'lang-select',
            items: getSupportedLanguages()
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          paddingRight: 0.5,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.ThemeModeToggler, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.CookieSettings, {})
        })]
      })]
    })]
  });
};
AccountAvatar.propTypes = {
  id: _propTypes.default.string.isRequired,
  colorInvert: _propTypes.default.bool
};
var _default = exports.default = AccountAvatar;